import { pipe } from '../../../common/utils/functionUtils';
import {
	boolStringToBool,
	emptyStringToNull,
	resetDataValue,
	resetIdentifyingFields,
} from '../common/helpers';
import {
	PrependAttrFormValues,
	PrependAttrPayload,
} from './prependAttributeTypes';

export const prependAttrFormDefaults = (): PrependAttrFormValues => ({
	operationType: 'prepend',
	singular: '',
	plural: '',
	isDerivation: 'false',
	delimiter: 'none',
	otherId: 0,
	otherValue: '',
	definition: '',
	usingStaticReference: 'true',
});

export const prependAttrFormToPayload = (
	formValues: PrependAttrFormValues
): PrependAttrPayload => {
	const baseValues = {
		...formValues,
		isDerivation: boolStringToBool(formValues.isDerivation),
		usingStaticReference: boolStringToBool(formValues.usingStaticReference),
		definition: emptyStringToNull(formValues.definition),
		delimiter:
			formValues.delimiter === 'none' ? null : formValues.delimiter,
	};

	return pipe(
		baseValues,
		resetIdentifyingFields(baseValues.isDerivation),
		resetDataValue(baseValues.usingStaticReference)
	);
};
